import { GET_TAGESDATEN_BY_STANDORTID_AND_ZEITRAUM } from '@/domain/termine/hooks/graphql/queries';
import { TerminKalender } from '@/domain/termine/shared/types/TerminKalender';
import { GetTagesDatenQuery } from '@/gql/graphql';
import { useSuspenseQuery } from '@apollo/client';

export function useTerminKalender(
  standortIds: string[],
  zeitraum: { von: string; bis: string },
): { kalender: TerminKalender[]; error: Error | null } {
  const { data, error } = useSuspenseQuery<
    GetTagesDatenQuery,
    { standortIds: string[]; zeitraum: { von: string; bis: string } }
  >(GET_TAGESDATEN_BY_STANDORTID_AND_ZEITRAUM, {
    variables: { standortIds, zeitraum },
    fetchPolicy: 'cache-and-network',
    errorPolicy: 'all',
  });

  if (error || !data) {
    return {
      kalender: [],
      error: error ?? new Error('No data'),
    };
  }

  const kalenderResult = data?.termine_termineKalenderByStandortIdAndZeitraum;
  if (!kalenderResult || kalenderResult.length === 0) {
    return { kalender: [], error: null };
  }

  const kalender = kalenderResult.map(
    (kalender) => new TerminKalender(kalender),
  );

  return { kalender, error };
}
